export default "__VITE_ASSET__tvXc33f2__"